// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
function ApiGetAllKategoriBarang(params: any): any {
    const baseUrl = '/api/admin/kategoribarang';
    return api.get(`${baseUrl}`, params);
}
function ApiGetAllBarang(params: any): any {
    const baseUrl = '/api/admin/barang';
    return api.get(`${baseUrl}`, params);
}
function ApiPostCategoryBarang(params: any): any {
    const baseUrl = '/api/admin/kategoribarang';
    return api.create(`${baseUrl}`, params);
}
function ApiPostBarang(params: any): any {
    const baseUrl = '/api/admin/barang';
    return api.create(`${baseUrl}`, params);
}
function ApiEditKategoriBarang(params: any, id: any): any {
    const baseUrl = '/api/admin/kategoribarang/' + id;
    return api.update(`${baseUrl}`, params);
}
function ApiEditBarang(params: any, id: any): any {
    const baseUrl = '/api/admin/barang/' + id;
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export {
    ApiGetAllKategoriBarang,
    ApiGetAllBarang,
    ApiPostCategoryBarang,
    ApiPostBarang,
    ApiEditKategoriBarang,
    ApiEditBarang,
    // ApiDeleteKategoriRoom,
};
